<div class="flex flex-col header mt-4 mb-4">
  <h1 class="text-2xl font-bold">{{'#COUPONS.EXISTING_PAGE.HEADER.TITLE' | translate }}</h1>
  <h3 class="text-lg font-bold color-light">{{(coupon$ | async)?.code}}</h3>
  <div class="flex flex-row justify-between row-no-wrap header-info mt-3 mb-4">
    <p class="text-body pr-5 line-height">
      {{'#COUPONS.EXISTING_PAGE.HEADER.INFO.DESCRIPTION' | translate }}
    </p>
    <div class="header-info-amount">
      <p class="coupon-amount-overline light uppercased">{{'#COUPONS.EXISTING_PAGE.HEADER.INFO.BALANCE' | translate }}</p>
      <div class="coupon-amount">{{ (coupon$ | async)?.balance || 0 | number:'1.2-2'}} EUR</div>
    </div>
  </div>
</div>

<div class="flex flex-col items-center actions mt-4 mb-3">
  <div class="flex flex-row justify-center coupon-action redeem mb-4 press-shadow" (click)="navigateTo('redeem')">
    <div class="flex flex-row justify-center content">
      <div class="content-icon mr-3">
        <i class="fa-regular fa-percent fa-3x mr-4"></i>
      </div>
      <div class="flex flex-col content-text ml-2">
        <h3 class="headline-3 mb-1">{{'#COUPONS.EXISTING_PAGE.REDEEM.TITLE' | translate }}</h3>
        <p class="text-body">{{'#COUPONS.EXISTING_PAGE.REDEEM.DESCRIPTION' | translate }}</p>
      </div>
    </div>
  </div>
  <div class="flex flex-row justify-center coupon-action charge mt-4 mb-4 press-shadow" (click)="navigateTo('charge')">
    <div class="flex flex-row justify-center content">
      <div class="content-icon mr-3">
        <i class="fa-regular fa-plus fa-3x mr-4"></i>
      </div>
      <div class="flex flex-col content-text ml-2">
        <h3 class="headline-3 mb-1">{{'#COUPONS.EXISTING_PAGE.CHARGE.TITLE' | translate }}</h3>
        <p class="text-body">{{'#COUPONS.EXISTING_PAGE.CHARGE.DESCRIPTION' | translate }}</p>
      </div>
    </div>
  </div>
</div>

<div class="flex flex-row justify-between footer mt-5 mb-2">
  <p class="text-body light">{{'#COUPONS.EXISTING_PAGE.FOOTER.INFO' | translate }}</p>
  <button class="soft-button secondary" (click)="cancel()">{{'#COUPONS.EXISTING_PAGE.FOOTER.CANCEL_BTN' | translate }}</button>
</div>


